/* eslint-disable import/no-unresolved */
// platformIcons.js - Object centralized of platform icons for global use
import whatsapp from 'images/integrations/wa.png';
import messenger from 'images/integrations/messenger.png';
import instagram from 'images/integrations/instagram.png';
import tiktokMessagesIcon from 'images/integrations/tiktok.png';
import facebookComment from 'images/new_design/fb-comments.svg';
import instagramComment from 'images/new_design/ig-comments.svg';

const PLATFORM_CONFIG = {
  whatsapp: {
    src: whatsapp,
    name: 'WhatsApp',
    alt: 'WhatsApp',
    icon: 'whatsapp-icon',
    cssIcon: 'whatsapp-line',
    color: 'tw-text-green-600',
    integratedKey: "whatsapp_integrated",
    platformKey: "whatsapp"
  },
  whatsapp_bsp_messages: {
    src: whatsapp,
    name: 'WhatsApp',
    alt: 'WhatsApp BSP Messages',
    icon: 'whatsapp-icon',
    cssIcon: 'whatsapp-line',
    color: 'tw-text-green-600',
    integratedKey: "whatsapp_integrated",
    platformKey: "whatsapp_bsp_messages"
  },
  whatsapp_qr_messages: {
    src: whatsapp,
    name: 'WhatsApp QR',
    alt: 'WhatsApp QR Messages',
    icon: 'whatsapp-icon',
    cssIcon: 'whatsapp-line',
    color: 'tw-text-green-600',
    integratedKey: "whatsapp_integrated",
    platformKey: "whatsapp_qr_messages"
  },
  whatsapp_gupshup_messages: {
    src: whatsapp,
    name: 'WhatsApp Gupshup',
    alt: 'WhatsApp Gupshup Messages',
    icon: 'whatsapp-icon',
    cssIcon: 'whatsapp-line',
    color: 'tw-text-green-600',
    integratedKey: "whatsapp_integrated",
    platformKey: "whatsapp_gupshup_messages"
  },
  messenger: {
    src: messenger,
    name: 'Messenger',
    alt: 'Messenger',
    icon: 'messenger-line',
    cssIcon: 'messenger-line',
    color: 'tw-text-blue-700',
    integratedKey: "messenger_integrated",
    platformKey: "messenger"
  },
  facebook_messages: {
    src: messenger,
    name: 'Facebook Messages',
    alt: 'Facebook Messages',
    icon: 'messenger-line',
    cssIcon: 'messenger-line',
    color: 'tw-text-blue-700',
    integratedKey: "messenger_integrated",
    platformKey: "facebook_messages"
  },
  instagram: {
    src: instagram,
    name: 'Instagram',
    alt: 'Instagram',
    icon: 'instagram-line',
    cssIcon: 'instagram-line',
    color: 'tw-text-purple-600',
    integratedKey: "instagram_integrated",
    platformKey: "instagram"
  },
  instagram_messages: {
    src: instagram,
    name: 'Instagram',
    alt: 'Instagram Messages',
    icon: 'instagram-line',
    cssIcon: 'instagram-line',
    color: 'tw-text-purple-600',
    integratedKey: "instagram_integrated",
    platformKey: "instagram_messages"
  },
  facebook_comments: {
    src: facebookComment,
    name: 'Facebook Comment',
    alt: 'Facebook Comment',
    icon: 'facebook-comment-icon',
    cssIcon: 'messenger-line',
    color: 'tw-text-blue-700',
    integratedKey: "fb_comments_integrated",
    platformKey: "facebook_comments"
  },
  instagram_comments: {
    src: instagramComment,
    name: 'Instagram Comment',
    alt: 'Instagram Comment',
    icon: 'instagram-comment-icon',
    cssIcon: 'instagram-line',
    color: 'tw-text-purple-600',
    integratedKey: 'ig_comments_integrated',
    platformKey: 'instagram_comments'
  },
  tik_tok_messages: {
    src: tiktokMessagesIcon,
    name: 'TikTok DM',
    alt: 'TikTok direct messages',
    icon: 'tiktok-icon',
    cssIcon: 'tiktok',
    color: 'tw-text-gray-800',
    integratedKey: 'tik_tok_messages_integrated',
    platformKey: 'tik_tok_messages'
  },
  tik_tok_comments: {
    src: tiktokMessagesIcon,
    name: 'TikTok Comments',
    alt: 'TikTok comments',
    icon: 'tiktok-icon',
    cssIcon: 'tiktok',
    color: 'tw-text-gray-800',
    integratedKey: 'tik_tok_comments_integrated',
    platformKey: 'tik_tok_comments'
  }
};

/**
 * Devuelve el nombre corto para mostrar en la UI (p. ej. "Enviar por").
 * Las variantes de WhatsApp (BSP / QR / Gupshup) se muestran como "WhatsApp",
 * sin exponer el proveedor interno.
 * @param {string} [platform]
 * @returns {string}
 */
export const getPlatformShortName = (platform) => {
  if (!platform) return '';
  if (platform.startsWith('whatsapp')) return PLATFORM_CONFIG.whatsapp.name;
  return PLATFORM_CONFIG[platform]?.name || platform;
};

export default PLATFORM_CONFIG;
